import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { setValueAtPath, getValueAtPath } from "~common/form/helper";
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import DefinitionSection from "~common/form/definition-section";
import {Grid} from '@mui/material';

type State = {
    data: any;
    form?: any;
    open: boolean;
    policyMessages: Array<any>;
    error?: any;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   open: boolean;
   validationData?: any;
   validationOptions?: any;
   confirmationMessage: string;
   onConfirm: ()=>void;
   onDeny: ()=>void;
   onClose: ()=>void
   isTerminal?: boolean;
  }

  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    }
})

class DataConfirmModal extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {}
      }

    UNSAFE_componentWillReceiveProps(nextProps:Props) {
        this.setState({open: nextProps.open, data: nextProps.validationData})
    }
   componentDidMount() {
        var { validationOptions, validationData } = this.props;
        var { data } = this.state;
        if (validationOptions && validationOptions.dialogFormSelector) {
          // get form
          request
            .get(
              `/api/form-definitions/select?selector=${URLManager.getQueryStringValue(
                validationOptions.dialogFormSelector
              )}`
            )
            .then((response: request.Response) => {
    
              this.setState({
                data: validationData,
                open: true,
                form: response.body,
              });
            })
            .catch((err: any) => {
              this.setState({
                error: (err.response || { text: err.toString() }).text,
              });
            });
        } else {
          this.setState({
            open: true,
          });
        }
      }


    handleConfirm = () => {
        this.props.onClose()
    }

    handleDeny = () => {
        this.props.onDeny()
        this.props.onClose()
    }

    handleClose = () => {
        this.props.onConfirm()
        this.props.onClose()
    }

    handleAccessRootData = (fullPath: string): any => {
        const { data } = this.state;
        // If the call has a conditional call that first, honoring the stopEvaluation as necessary
    
        var evalVal: any;
    
        // Since this is something that we are only evaluating here (_new) we will stop evaluation when we are done.
        fullPath = fullPath.replace(/^~/, "");
    
        evalVal = getValueAtPath(fullPath, data);
    
        return evalVal;
    };

    handleChangeAtPath = (path: string, value: any, fieldDef?: any) => {
        let { data } = this.state;
        let svpResp = setValueAtPath(path, data, value);

        data = svpResp.data;

        if (svpResp.err) {
            console.error(svpResp.err);
        }

        this.setState({ data }, () => {
            // this.clearMessagesAtPath(path);
        });
    };

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {confirmationMessage, open} = this.props
        const {data, form, policyMessages} = this.state

        let actionButtonClass = classes.primaryButton 
        if(this.props.isTerminal){
            actionButtonClass = classes.dangerButton 
        }
        var constructedData = {
            evaluatedData: {},
            lastRequest: {}
        }
        if (data ) {
            if (data.evaluatedData) {
                
                for (const [key, value] of Object.entries(data.evaluatedData)) {
                    const keyBase = key.split('/').pop();
                    constructedData.evaluatedData[keyBase] = value
                }
            }
            if (data.lastRequest) {
                for (const [key, value] of Object.entries(data.lastRequest)) {
                    const keyBase = key.split('/').pop();
                    constructedData.lastRequest[keyBase] = value
                }
            }
        }





        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
            >   
                <DialogContent className={classes.modalContent}>
                { false && 
                    <DialogTitle className={classes.modalTitle}>
                        Confirm
                    </DialogTitle>  
                }
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography variant="subtitle1">{confirmationMessage}</Typography> 
                        </Grid>
                        {form && (
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <DefinitionSection
                            data={constructedData}
                            definition={form}
                            path={""}
                            policyMessages={policyMessages}
                            onChangeAtPath={this.handleChangeAtPath}
                            onAccessRootData={this.handleAccessRootData}
                            gridSpacing={4}
                            preventCollapse={true}
                            suppressTitle={true}
                            />
                        </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button 
                        id="noButton"
                        variant="contained"
                        color="inherit"
                        onClick={this.handleDeny}>
                        No
                    </Button>
                    <Button 
                        id="yesButton"
                        autoFocus={true}
                        variant="contained"
                        color="secondary"
                        className={actionButtonClass} 
                        onClick={this.handleConfirm}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(DataConfirmModal);